const loadingLabel = "Φόρτωση";
const elCY = {
  loadingLabel
};
export {
  elCY as default,
  loadingLabel
};
